import { render } from "./LiveChat.vue?vue&type=template&id=7e4bb9e8"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"

import "./LiveChat.vue?vue&type=style&index=0&id=7e4bb9e8&lang=less"

import exportComponent from "C:\\Users\\Admin\\Desktop\\dev\\dma-sc-question-edits\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__